import api from "services/api";

// Get all attendance policies
export const getAttendancePolicies = async (params = {}) => {
  return api.get("/v1/api/admin/attendance-policies", { params });
};

// Get attendance policy by ID
export const getAttendancePolicyById = async (id) => {
  return api.get(`/v1/api/admin/attendance-policies/${id}`);
};

// Create attendance policy
export const createAttendancePolicy = async (data) => {
  return api.post("/v1/api/admin/attendance-policies", data);
};

// Update attendance policy
export const updateAttendancePolicy = async (id, data) => {
  return api.put(`/v1/api/admin/attendance-policies/${id}`, data);
};

// Delete attendance policy
export const deleteAttendancePolicy = async (id) => {
  return api.delete(`/v1/api/admin/attendance-policies/${id}`);
};
